export default function(_) {
  return Object.prototype.toString.call(_) === '[object Date]';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isDate.js